<template>
  <div class="treeContainer">
    <div class="title clearfix">
      <p class="fl">单位信息</p>
    </div>
    <div class="treeBox">
      <el-scrollbar v-if="isPermit('org:query')" wrap-class="scrollbar-wrapper">
        <el-tree v-loading="treeLoading" class="tree" ref="tree" :indent=8 :data="treeData" how-checkbox node-key="id" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" :style="{paddingRight:treeHandler ? '60px' : '0'}" slot-scope="{ node, data }">
            <span class="treeLabel" :title="showLabel(node.label)" >{{ showLabel(node.label) }}</span>
          </span>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
const defaultTreeForm = { name: "", serial: 50 };
var qs = require("qs");
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      treeLoading: false,
      addLoading: false,
      editLoading: false,
      treeHeight: "",
      treeHandler: false,
      superAdminFlag: false,
      treeData: [],
      expandAll: true,
      defaultChecked: [],
      isAddOperation: true,
      addModel: false,
      addForm: defaultTreeForm,
      // orgRules: {
      //   name: [
      //     { required: true, message: "请输入组织机构名称", trigger: "blur" },
      //     {
      //       min: 1,
      //       max: 15,
      //       message: "负责人姓名长度在 1 到 15 个字符",
      //       trigger: "change"
      //     }
      //   ],
      //   code: [
      //     { required: true, message: "请输入组织机构代码", trigger: "blur" },
      //     {
      //       min: 1,
      //       max: 30,
      //       message: "组织机构长度在 1 到 30 个字符",
      //       trigger: "change"
      //     }
      //   ]
      // },
      currentTreeId: 0,
      orgOptions: []
    };
  },
  created() {
    this.queryTreeNode()
  },
  mounted() {
  },
  methods: {
    treeInit() {
      // console.log(this.$refs.tree.store.nodesMap);
      let nodes = this.$refs.tree.store.nodesMap;
      console.log(nodes);
      
      for (const key in nodes) {
         console.log(key);
        nodes[key].isCurrent = false;
      }
      nodes[this.treeData[0].id].isCurrent = true;
      this.currentTreeId = this.treeData[0].id;
      this.$emit("currentTreeIdChange", this.currentTreeId)
    },
    expandAllChange() {
      this.expandAll = !this.expandAll;
      let nodes = this.$refs.tree.store.nodesMap;
      for (const key in nodes) {
        nodes[key].expanded = this.expandAll;
      }
    },

    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // 查询组织机构
    queryTreeNode(pid = 0) {
      this.treeLoading = true;
      this.request
        .get(`/organization/findTreeById?id=${pid}`)
        .then(data => {
          console.log(data);
          this.treeData = data.code === 200 ? data.data : [];
          this.$emit("treeData", this.treeData);
          this.treeLoading = false;
          this.$nextTick(() => {
            this.treeInit();
          });
          // this.currentTreeId =
          //   this.treeData.length > 0 ? this.treeData[0].value : 0;
        })
        .catch(error => (this.treeData = []));
    },
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? item.id : 0;
      this.$emit("currentTreeIdChange", this.currentTreeId); //传过去改变的值，监控这个值，如果发生改变，调用查询人员方法
    },
  }
};
</script>

<style lang="scss" scoped>
.treeContainer {
  // width: 236px;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  height: 100%;
  .title {
    position: absolute;
    width: 100%;
    height: 38px;
    top: 0;
    left: 0;
    box-sizing: border-box;
    padding: 0 10px;
    p {
      line-height: 38px;
    }
    .handlerBox {
      height: 24px;
      margin-top: 7px;
      font-size: 0;
      i {
        display: inline-block;
        margin-left: 6px;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }
  .treeBox {
    padding: 48px 0 10px;
    height: 100%;
    box-sizing: border-box;
    .tree {
      padding: 0 10px;
      .custom-tree-node {
        display: block;
        width: 100%;
        padding-left: 26px;
        box-sizing: border-box;
        position: relative;
        .treeLabel {
          width: 100%;
          font-size: 14px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333;
        }
        .treeBtn {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 0;
          i {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin: 0 3px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.treeContainer {
  .treeBox {
    .tree {
      .el-tree-node {
        .el-tree-node__content {
          height: 40px;
          position: relative;
          .el-tree-node__expand-icon {
            position: absolute;
            // left: 0;
            z-index: 10;
            font-size: 16px;
            color: #888;
            &.is-leaf {
              color: transparent;
            }
          }
        }
        .custom-tree-node {
          height: 40px;
          line-height: 40px;
        }
      }
      .is-current {
        & > .el-tree-node__content {
          & > .el-tree-node__expand-icon {
            color: #2177E6;
          }
          & > .custom-tree-node {
            .treeLabel {
              color: #2177E6;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>

